<template>
  <div ref="container" :class="props.splitView ? 'split-view-pdf-viewer' : 'responsive-pdf-viewer'" />
</template>
<script setup lang="ts">
import { useTemplateRef, onMounted, onUnmounted } from "vue";
import { NutrientDocumentAuth } from "@/types/types";
import { $api } from "@/services/api1";
import { usePdfViewerModalStore } from "@/store/store/pdfViewerModalStore";

const containerRef = useTemplateRef("container");
let NutrientSDK: typeof window.NutrientViewer | undefined;

const props = defineProps<{
  docId?: number;
  splitView?: boolean;
}>();

const pdfViewerModalStore = usePdfViewerModalStore();

async function getTokenData(docId: number): Promise<NutrientDocumentAuth> {
  return await $api.documents.getNutrientToken(docId);
}

onMounted(async () => {
	if (!props.docId) {
		return;
	}
  NutrientSDK = window.NutrientViewer;
  const container = containerRef.value;
  const resp = await getTokenData(props.docId);

  if (container && NutrientSDK) {
    NutrientSDK.load({
      container,
      useCDN: true,
      authPayload: { jwt: `${resp.venderToken}`},
      documentId: `${resp.vendorId}`,
      instant: false,
      licenseKey: resp.licenseKey,
      serverUrl: `${resp.serverUrl}`
    }).then((doc) => {
      pdfViewerModalStore.pdfModal.pageCount = doc.totalPageCount;
    })
    .catch((error: any) => {
      console.error(error);
    });
  }
});

onUnmounted(() => {
  const container = containerRef.value;
  if (container && NutrientSDK) {
    NutrientSDK.unload(container);
  }
});

</script>



<style scoped>
.split-view-pdf-viewer {
  width: 65vw;
  height: 80vh;
}
.responsive-pdf-viewer {
  width: 100%;
  height: 80vh;
}

@media (max-width: 1024px) {
  .split-view-pdf-viewer,
  .responsive-pdf-viewer {
    height: 70vh;
  }
}

@media (max-width: 600px) {
  .split-view-pdf-viewer,
  .responsive-pdf-viewer {
    height: 60vh;
  }
}
</style>
 